import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ProjectService } from 'src/services/project.service'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useEffect } from 'react'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { ConfigurationHeaderWrapper } from '../_components/configuration-header-wrapper.component'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import ContentList from './_components/content-list.component'
import { TContent } from './_components/content.type'

export default function ContentsPage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { project } = useCurrentProject()

  const { isLoading, error, data } = useQuery({
    queryKey: ['contents', project.id],
    queryFn: () => ProjectService.getSelfConfigurationContents(project.id),
  })

  useEffect(() => {
    if (data && data.length === 0) navigate(`/${project.id}/configuration/contents/add`, { replace: true })
  }, [data, project.id, navigate])

  if (error) return <ErrorQueryHandler error={error} />
  if (isLoading) return <div className="loading" />

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.contents.content-list')}>
      <ContentList contents={data as TContent[]} />
    </ConfigurationHeaderWrapper>
  )
}
